import React, { Fragment } from 'react';
import { Container, Col, Row, Card, CardBody, Button, Input, Form, FormGroup,ListGroup, ListGroupItem, Spinner   } from 'reactstrap';
import { TableStriped } from '../../../../components/tables/TableStriped';
import { useExamMicrobiology } from '../../../../hooks/micro/useExamMicrobiology';
import { ModalExamMicrobiology } from '../../../../components/examsMicrobiology/ModalExamMicrobiology';
import { ModalIndicationExamMicrobiology } from '../../../../components/examsMicrobiology/ModalIndicationExamMicrobiology';
import { ModalReleaseExamMicrobiology } from '../../../../components/examsMicrobiology/ModalReleaseExamMicrobiology';
import { Dialog } from 'primereact/dialog';
import Select from 'react-select';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AlertDataTable } from '../../../../components/tableDataTable/AlertDataTable';
import { TitleDataTable } from '../../../../components/tableDataTable/TitleDataTable';

export const IndexExamsMicrobiology = () => {
    const {
        exams, method, handleInputChange, validaciones,
        sections, formats, specimenOrigins, subSections, commercialLines, specimens, specimenProvenances, typeTransports, transports,
        id_section, id_format_sanitary, id_subsection, id_specimen_origin, code, alias, name, abbreviation, individual_sale, cost, is_referenced, listExternalLaboratories, is_critic,
        closeDialog, modal, modalTitle, loading, examId, getUpdateDefaultExternalLaboratory,
        changeSelect, handleSelectValues,
        handleCreate, saveCreate, saveUpdate,
        handleDelete, saveDelete,
        navigateConfigExam, navigateEditExamSimple,
        handleChangePrice,
        goNextPage, goPreviousPage, goToPage, actualPage, totalPages,
        formValues, handleSearch,
        //INDICATION
        toggle2, modal2, handleListProfile, listIndications, indication, handleChangeIndication,
        id_exam_indication, indicationn, listIndication, selectIndication, removeExamProfile,
        CreateOrUpdateExamIndications,
        handleGetValidReleaseExam, releaseExam, modalReleaseExam, toggleRelease, loadingReleaseExam,
        saveUpdateStatusComplete,
      
        handleSelectValuesIndication, dataIndication,
       
        isImagenologyy, navigateMicroAnalytes, use_antibiogram, print_new_page,
        listIndicationLab, CreateOrUpdateExamLabIndications, handleSelectValuesIndication2, dataIndicationLab,

        _active_micro,hideModal,visible,showModal,listNorm,listRulesE,handleSelectValuesRules,saveListRules,nameExam,

        loadingSaveListRules,
        downloadExcelMicro, loadingExcel,
        handleClearExamMicro, searchExamMicro,
        showDeleteAlert, modalAlert, closeDeleteAlert



    } = useExamMicrobiology();

    // * CATALOG NORM
    const CatalogNom = _active_micro === "True" &&  {
        type: "linkId",
        method: showModal,
        icon: "fa fa-check-square-o",
        backgroundColor: "#f97316",
        color: "#fff",
        tooltip: "Asociar Norma",
        name: "showModal",

    }

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>

                <button
                    size="sm"
                    onClick={() => navigateConfigExam(rowData.id_exam)}
                    title="Método del examen"
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#70cbe8", 
                        color: "#fff",               
                        border: "none",             
                        borderRadius: "4px"          
                    }}
                >
                    <i className="fa fa-cogs f-12"></i>
                </button>

                <button
                    size="sm"
                    onClick={() => navigateMicroAnalytes(rowData.id_exam)}
                    title="Agregar analito"
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#0ba1d6", 
                        color: "#fff",               
                        border: "none",             
                        borderRadius: "4px"          
                    }}
                >
                    <i className="fa fa-cog f-12"></i>
                </button>

    
                <button
                    size="sm"
                    onClick={() => handleGetValidReleaseExam(rowData.id_exam)}
                    title="Liberar examen"
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#01839d", 
                        color: "#fff",               
                        border: "none",             
                        borderRadius: "4px"          
                    }}
                >
                    <i className="fa fa-check f-12"></i>
                </button>

                <Button 
                    size="sm"
                    onClick={() => navigateEditExamSimple(rowData.id_exam)}
                    // disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#1875c5", 
                        color: "#fff",               
                        border: "none",             
                        borderRadius: "4px"          
                    }}                >
                    <i className="fa fa-edit f-12"></i>
                </Button>

                <button
                    size="sm"
                    onClick={() => handleListProfile(rowData.id_exam)}
                    title="Indicaciones del Exámen"
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#016392", 
                        color: "#fff",               
                        border: "none",             
                        borderRadius: "4px"          
                    }}
                >
                    <i className="icofont icofont-prescription"></i>
                </button>
                
                {_active_micro === "True" && (
                    <button
                        size="sm"
                        onClick={() => showModal(rowData.id_exam)}
                        title="Asociar Norma"
                        style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#f97316",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px"
                        }}
                    >
                        <i className="fa fa-check-square-o f-12"></i>
                    </button>
                )}


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.id_exam)}
                    // disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };

        
    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };



    return (
        <Fragment>
            <div className="container-global-zoom" >
                <Row>
                    <Col xs="12" sm="12" md="12" lg="12" xl="12">
                        <Card>
                            <CardBody className="p-1">

                                  <div style={{ 
                                        backgroundColor: '#105e8f', 
                                        color: '#fff', 
                                        padding: '5px 10px', 
                                        borderRadius: '8px', 
                                        marginBottom: '10px', 
                                        fontWeight: 'bold', 
                                        textAlign: 'center',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                    }}>
                                       
                                       <h6>
                                        EXAMENES DE MICROBIOLOGIA
                                        
                                        </h6>

                                </div>                    
                                <Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
                                    <TitleDataTable
                                        titleTable="Listado de Examenes de Microbiología "
                                        buttonActions={downloadExcelMicro}
                                        titleButton="listado de examenes de micro "
                                        isDisbled={loadingExcel}
                                        loadingIsDisabled={loadingExcel}
                                        titleCreate="Crear Vendedor"
                                        buttonActionsCreate={handleCreate}
                                        actionInput={handleSearch}
                                        valueFilter={searchExamMicro}
                                        filterLocalStorage={true}
                                        cleanFilterLocalStorage={handleClearExamMicro}
                                    />
                                </Col>
                                                 


                                <div className="table-responsive">

                                    <DataTable
                                        value={exams}
                                        lazy
                                        paginator
                                        first={(actualPage - 1) * 10} 
                                        rows={10}
                                        totalRecords={totalPages * 10} 
                                        onPage={(e) => goToPage(e.page + 1)}
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                {/* <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "25%" }} alt="Sin Examenes" /> */}
                                                <br />
                                                <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                                    Sin Examenes.
                                                </p>
                                            </div>
                                        }
                                        // rowsPerPageOptions={[10, 50, 100]}
                                        responsiveLayout="scroll"
                                    >
                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="code" header="Clave"  headerStyle={headerStyle} style={cellStyle}/>
                                        <Column field="name" header="Nombre" headerStyle={headerStyle} style={cellStyle}/>
                                        <Column field="abbreviation" header="Abreviatura"  headerStyle={headerStyle} style={cellStyle}/>
                                        <Column field="name_section" header="Sección/Área" headerStyle={headerStyle} style={cellStyle}/>
                                        <Column field="is_complete" header="Examen terminado" headerStyle={headerStyle} style={cellStyle}/>
                                        <Column field="typeExam" header="Tipo de examen" headerStyle={headerStyle} style={cellStyle}/>
                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={cellStyle} />
                                    </DataTable>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            {showDeleteAlert && (
                <AlertDataTable
                    titleAlert="Eliminar Morfología"
                    visibleAlert={modalAlert}
                    onHideAlert={closeDeleteAlert}
                    sizeAlert="medium-dialog delete-method"
                    messageAlert="Esta acción no se puede deshacer. ¿Estás seguro de eliminar la morfología?"
                    alert1={true}
                    titleAlert1={`${alias} - ${name}`}
                    buttonAcept
                    titleNotLoading="Eliminar"
                    titleDanger="Cancelar"
                    actionAcept={saveDelete}
                    
                />
            
            )}

            <ModalExamMicrobiology
                {
                ...{
                    formValues, method, handleInputChange, validaciones, handleSelectValues,
                    sections, formats, specimenOrigins, subSections, commercialLines, specimens, specimenProvenances, typeTransports, transports,
                    id_section, id_format_sanitary, id_subsection, id_specimen_origin, code, alias, name, abbreviation, individual_sale, cost, is_referenced,
                    closeDialog, modal, modalTitle, loading, listExternalLaboratories, examId, getUpdateDefaultExternalLaboratory, is_critic,
                    changeSelect,
                    saveCreate,
                    saveUpdate,
                    saveDelete,
                    handleChangePrice, isImagenologyy, use_antibiogram, print_new_page

                }
                }
            />

            <ModalIndicationExamMicrobiology
                {
                ...{
                    toggle2, modal2, modalTitle, loading, method, listIndications, indication, handleChangeIndication,
                    id_exam_indication, indicationn, listIndication, selectIndication, removeExamProfile,
                    CreateOrUpdateExamIndications,
                    handleSelectValuesIndication, dataIndication,
                    listIndicationLab, CreateOrUpdateExamLabIndications, handleSelectValuesIndication2, dataIndicationLab

                }
                }
            />

            <ModalReleaseExamMicrobiology
                {
                ...{
                    releaseExam, modalReleaseExam, toggleRelease, loadingReleaseExam,
                    saveUpdateStatusComplete
                }
                }
            />
            <Dialog
                header={<label className='f-w-600'>Normas asociadas a {nameExam}</label>}
                visible={visible}
                onHide={hideModal}
                closable={true}
                className='large-dialog'
                headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold'
            }}
             footer={
                <div className="d-flex justify-content-end gap-2">
                    <button className="btn btn-outline-primary btn-sm"  onClick={() => saveListRules() } disabled={loadingSaveListRules}>
                        {loadingSaveListRules ? (
                            <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" />
                            Guardando...
                            </>
                        ) : (
                            "Guardar"
                        )}
                    </button>

                    <button className="btn btn-danger btn-sm" onClick={hideModal} >
                        Cerrar
                    </button>
                </div>
            }    
            >
                <Col sm="12">
                <Col sm="12" className='p-l-0 p-r-0' >
                <Row>
                    <Col sm="6"> <br />
                    <label className='f-w-600' style={{color:"#0d3b59"}}  >Seleccionas las normas para este estudio</label>
                    <Select
                        isMulti
                        name="listRulesE"
                        value={listRulesE}
                        onChange={(e) => handleSelectValuesRules(e, "listRulesE")}
                        options={listNorm}
                        className="basic-multi-select form-control form-control-plaintext"
                        classNamePrefix="select"
                        placeholder="Selecciona una o varias opciones"
                        noOptionsMessage={() => "Sin opciones"}
                        isSearchable={true}
                        menuPortalTarget={document.body}  
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                    fontSize: '11px', 
                                }),
                                option: (provided) => ({
                                    ...provided,
                                    fontSize: '11px', 
                                }),
                                placeholder: (provided) => ({
                                    ...provided,
                                    color: "#b6bdc4",
                                    fontSize: '11px', 
                                }),
                                singleValue: (provided) => ({
                                    ...provided,
                                    fontSize: '11px',
                                }),
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999999, 
                                }),
                            }}
                    />
                    </Col>
                    <Col sm="6"> <br />
                    <b style={{color:"#0d3b59"}}>Normas asociadas</b>
                            <ListGroup className='pt-2' >
                                {
                                    listRulesE.length > 0 ? (
                                        listRulesE.map((_find, _key) => (
                                            <ListGroupItem key={_key} className="d-flex justify-content-between align-items-center list-group-item-action">
                                                <label className='f-w-600' style={{fontSize:"10px"}}>{_find?.label ?? "----"}</label>
                                                <i className="fa fa-check text-success"></i>
                                            </ListGroupItem>
                                        ))
                                    ) : (
                                        <ListGroupItem className="d-flex justify-content-center align-items-center">
                                            <i className='fa fa-warning text-danger' ></i>
                                            <label className='f-w-600 txt-danger pt-1' style={{fontSize:"11px"}}>No se a asigando una norma en esta prueba</label> 
                                        </ListGroupItem>
                                    )
                                }
                            </ListGroup>
                    </Col>
                </Row>
                </Col>
                <br /><br />
                </Col> 
            </Dialog>
        </Fragment >
    )
}